import { entityTypesEnum } from "helpers/enums";
import React from "react";

const translateItems = {
    [entityTypesEnum.TruckingBid]: {
        bid: "заявки",
        distributionBid: "заказа",
    },
    [entityTypesEnum.Cargo]: {
        bid: "груза заявки",
        distributionBid: "груза заказа",
    },
    [entityTypesEnum.BidPoint]: {
        bid: "точки заявки",
        distributionBid: "точки заказа",
    },
};

const ItemHiddenSelect = withChangeHandler((props) => {
    const { intFlags, intRelationFlags, setRelationValue, flagVal, disabled, kind, name } = props;

    return (
        <select
            name={name}
            disabled={disabled}
            className="form-control form-control-xs"
            value={`${intFlags & flagVal}_${intRelationFlags & flagVal}`}
            onChange={setRelationValue}
        >
            <option value={`0_0`}>Видим для всех</option>
            <option value={`${flagVal}_0`}>Невидим только для {translateItems[kind].bid}</option>
            <option value={`0_${flagVal}`}>Невидим только для {translateItems[kind].distributionBid}</option>
            <option value={`${flagVal}_${flagVal}`}>Невидим для всех</option>
        </select>
    );
});

const ItemRequiredSelect = withChangeHandler((props) => {
    const { intFlags, intRelationFlags, setRelationValue, flagVal, disabled, kind, name } = props;

    return (
        <select
            name={name}
            disabled={disabled}
            className="form-control form-control-xs"
            value={`${intFlags & flagVal}_${intRelationFlags & flagVal}`}
            onChange={setRelationValue}
        >
            <option value={`0_0`}>Необязателен для всех</option>
            <option value={`${flagVal}_0`}>Обязателен только для {translateItems[kind].bid}</option>
            <option value={`0_${flagVal}`}>Обязателен только для {translateItems[kind].distributionBid}</option>
            <option value={`${flagVal}_${flagVal}`}>Oбязателен для всех</option>
        </select>
    );
});

function withChangeHandler(WrappedComponent) {
    return function (props) {
        const { disabled, intFlags, intRelationFlags, setFlags, setRelationFlags, flagVal, action } = props;
        const setRelationValue = (e) => {
            if (disabled) {
                return;
            }

            const [value, relationValue] = e.target.value.split("_").map((item) => parseInt(item));
            const flagChecked = (intFlags & flagVal) === flagVal;
            const relationFlagChecked = (intRelationFlags & flagVal) === flagVal;

            const getVal = (checked, flags, value) => {
                if (value === 0 && !checked) {
                    return flags;
                }
                if (value > 0 && checked) {
                    return flags;
                }
                return checked ? flags - flagVal : flags + flagVal;
            };

            const newFlagVal = getVal(flagChecked, intFlags, value);
            const newRelationFlagVal = getVal(relationFlagChecked, intRelationFlags, relationValue);

            setFlags(newFlagVal);
            setRelationFlags(newRelationFlagVal);
            return action({ flags: newFlagVal, relationFlags: newRelationFlagVal });
        };

        return <WrappedComponent setRelationValue={setRelationValue} {...props} />;
    };
}

export { ItemHiddenSelect, ItemRequiredSelect };
